import { useContext, useEffect, useState } from "react";
import './loginform.css'
import Form from 'react-bootstrap/Form';
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faHouse } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { Link, useNavigate } from 'react-router-dom';

import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Success_modal from "../common-section/Modals/Success_modal/Success_modal";
import { resetPassWord } from "../../utils/apis/common/Common";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { Context } from "../../utils/context";


const Setnew_password = () => {

    const { resetEmail } = useContext(Context);
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");

    const navigate = useNavigate()

    const {
        control,
        register,
        handleSubmit,
        setError,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();

    const [phoneValue, setPhoneValue] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [err, setErr] = useState()

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };


    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [confirmPasswordVisible2, setConfirmPasswordVisible2] = useState(false);
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };
    const toggleConfirmPasswordVisibility2 = () => {
        setConfirmPasswordVisible2(!confirmPasswordVisible2);
    };



    const onSubmit = async (data) => {

        console.log("onSubmit", data, resetEmail)


        const isEmail = /^\S+@\S+\.\S+$/.test(resetEmail);
        const isPhoneNumber = /^\d{10}$/.test(resetEmail);

        let payload = {}

        if (isEmail) {
            payload = {
                email: resetEmail,
                new_password: data?.password
            }
        }

        if (isPhoneNumber) {
            payload = {
                contact_no: resetEmail,
                new_password: data?.password
            }
        }

        if (data.password === data.confirm_password) {
            console.log(payload, "payload");


            const res = await resetPassWord(payload);
console.log(res,'res res');

            if (res?.success) {
                setModalShow(true)
                setTimeout(() => {
                    navigate("/login")
                }, 3000);
            }else{
                setError("confirm_password", {
                    message:res.message,
                });
            }

        } else {
            setError("confirm_password", {
                message: "Password Must Match",
            });
        }

    };


    return (
        <>
            <section className='login-page-main-sec'>
                <div className='container'>
                    <div className='main-position-div'>
                        <div className='d-flex aligndiv'>


                            <div className='mid-img-div'>
                                <img src={process.env.PUBLIC_URL + '/assets/images/login/mid-img2.png'} />
                            </div>

                            <div className='last-div slidein margin-top'>
                                <div className='loginformsec topspace'>
                                    <Link to="/forgot-password"><FontAwesomeIcon className='home-icn' icon={faChevronLeft} /></Link>
                                    <h1 className='login-title'>Set New Password</h1>
                                    <p className='loginby'>Your new password must be different to previously
                                        used password.</p>

                                    <div className='form-div '>
                                        <Form onSubmit={handleSubmit(onSubmit)}>


                                            <Form.Group className='form-group mt-5'>
                                                <Form.Label>Enter Password</Form.Label>
                                                <Form.Control
                                                    type={passwordVisible ? "text" : "password"}
                                                    name="Password"
                                                    placeholder="Enter Password"
                                                    // className={classNames("", {
                                                    //     "is-invalid": errors?.password,
                                                    // })}
                                                    {...register("password", {
                                                        required: "Password is required",
                                                        minLength: {
                                                            value: 8,
                                                            message:
                                                                "Password must be at least 8 characters long",
                                                        },
                                                        pattern: {
                                                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                                            message:
                                                                "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                                                        },
                                                    })}
                                                    onChange={(e) => setPassword(e.target.value)}

                                                />
                                                {/* <FontAwesomeIcon className='eye-icc' icon={faEye} /> */}
                                                <div
                                                    className="eye-icc-holder"
                                                    onClick={togglePasswordVisibility}
                                                >
                                                    <FontAwesomeIcon
                                                        className="eye-icc"
                                                        icon={
                                                            passwordVisible ? faEye : faEyeSlash
                                                        }
                                                    />
                                                </div>
                                            </Form.Group>

                                            <Form.Group className='form-group mb-5'>
                                                <Form.Label>Confirm Password</Form.Label>
                                                <Form.Control
                                                    type={confirmPasswordVisible ? "text" : "password"}
                                                    name="Password"
                                                    placeholder="Enter Confirm Password"
                                                    // className={classNames("", {
                                                    //     "is-invalid": errors?.confirm_password,
                                                    // })}
                                                    {...register("confirm_password", {
                                                        required: "Password is required",
                                                    })}
                                                    onChange={(e) =>
                                                        setPasswordAgain(e.target.value)
                                                    }
                                                />
                                                {/* <FontAwesomeIcon className='eye-icc' icon={faEye} /> */}
                                                <div
                                                    className="eye-icc-holder"
                                                    onClick={toggleConfirmPasswordVisibility}
                                                >
                                                    <FontAwesomeIcon
                                                        className="eye-icc"
                                                        icon={
                                                            confirmPasswordVisible ? faEye : faEyeSlash
                                                        }
                                                    />
                                                </div>
                                                {errors.confirm_password && (
                                                    <span className="text-danger">
                                                        {errors.confirm_password.message}
                                                    </span>
                                                )}

                                                {password && (
                                                    <PasswordChecklist
                                                        rules={[
                                                            "minLength",
                                                            "specialChar",
                                                            "number",
                                                            "capital",
                                                            "match",
                                                        ]}
                                                        minLength={8}
                                                        value={password}
                                                        valueAgain={passwordAgain}
                                                        onChange={(isValid) => { }}
                                                        style={{
                                                            fontSize: "10px",
                                                            padding: "4px",
                                                            margin: "0",
                                                        }}
                                                    />
                                                )}
                                            </Form.Group>

                                            <p className="otp text text-danger">{err}</p>

                                            <button type="submit" className='Login-btn resetpasstop'>Submit</button>
                                        </Form>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Success_modal
                maintext={"Password Reset Successfully"}
                smalltext={""}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    )
}

export default Setnew_password